// constants
import { MOBILE_CHECKOUT_URI } from "shared/constants/uri";

let isReactCheckoutEnabled = false;
let reactQueryString = "";

export const setMobileCheckoutData = (isReactEnabled: boolean, queryString = "") => {
    isReactCheckoutEnabled = isReactEnabled;
    reactQueryString = queryString;
};

export const getMobileCheckoutURI = () =>
    isReactCheckoutEnabled ? `${MOBILE_CHECKOUT_URI}?${reactQueryString}=1` : MOBILE_CHECKOUT_URI;
